/**
 * Module definition for cases module. The cases module manages
 * the application's top-level cases view (i.e., /cases).
 *
 * @module routes.cases
 */

angular.module('routes.cases', [
  'stack',
  'routes.cases.states',
  'routes.cases.widgets',
  'routes.cases.constants',
  'routes.cases.CasesController',
  'routes.cases.CasesPayloadResolver',
  'ui.tinymce',
  'schemaForm',
  'schemaFormAddons' // This is custom and located in components/authoring
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.cases', {
          url: '/cases/:caseId',
          templateUrl: 'routes/cases/cases.html',
          controller: 'CasesController',
          params: {
            caseId: { value: null, squash: true }
          },
          resolve: {
            constants: [
              'ConstantResolver',
              'CASES',
              function (ConstantResolver, CASES) {
                return new ConstantResolver(CASES);
              }
            ],
            casesPayload: [
              'CasesPayloadResolver',
              '$stateParams',
              'newmanPayload',
              function (CasesPayloadResolver, $stateParams, newmanPayload) {
                return new CasesPayloadResolver($stateParams, newmanPayload);
              }
            ]
          }
        }
      );
    }
  ]
);
